import React from 'react';
import './About.css';

import { Button, Heading } from '../../../components';
import { about } from '../../../constants';

import { HiOutlineLightBulb } from 'react-icons/hi';



const About = () => {

  const { sub, heading, description, points, image, button } = about;

  // Split features into 2 groups
  const mid = Math.ceil(points.length / 2);
  const firstGroup = points.slice(0, mid);
  const secondGroup = points.slice(mid);

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <img src={image.src} alt={image.alt} />
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        {description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        {/* Key Features */}
        <div className="about-features two-columns">

          <div className="features-column">
            {firstGroup.map((point, index) => (
              <ul key={index}>
                <li>
                  <div className='icon'><HiOutlineLightBulb /></div>
                  <span>{point}</span>
                </li>
              </ul>
            ))}
          </div>

          <div className="features-column">
            {secondGroup.map((point, index) => (
              <ul key={index}>
                <li>
                  <div className='icon'><HiOutlineLightBulb /></div>
                  <span>{point}</span>
                </li>
              </ul>
            ))}
          </div>
        </div>

        {/* Button Component */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;
